import { render, staticRenderFns } from "./BlockConfiguration.vue?vue&type=template&id=3030e662&"
import script from "./BlockConfiguration.vue?vue&type=script&lang=js&"
export * from "./BlockConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports